export default __webpack_public_path__ + "static/hero-footer-bf4cc2ee760afaacc74f38b49ddfc3a4.svg";